export default "__VITE_ASSET__oJ$WoSYx__"